module.exports = __webpack_public_path__ + "img/1.e4e45ff6.jpg";